module.exports = require("domain");